export default ".sma-select{height:40px;font-size:10pt;width:100%}";